module.exports = __webpack_public_path__ + "static/media/walker.f6e98c01.svg";